<template>
  <div>
    <div class="d-flex justify-content-end align-items-center">
      <el-button style="background-color: #5D04B0" @click="dialogCancelContractVisible=true" size="mini" class="mb-2 text-white">Hủy hợp đồng</el-button>
    </div>
    <div class="process-wrap">
      <!-- LEFT: steps + step content -->
      <div class="process-left">
        <div class="process-left__box">
          <!-- STEPS BAR -->
          <div class="stepbar">
            <div
                v-for="(s, idx) in steps"
                :key="s.key"
                class="stepbar__item w-100"
                :class="{
      'is-done': idx < stepBarCurrentIndex,
      'is-active': idx === stepBarCurrentIndex,
      'is-todo': idx > stepBarCurrentIndex,
      'is-disabled': idx > stepBarMaxIndex
    }"
                @click="changeStepBar(idx)"
            >
              <div class="stepbar__icon">
                <i :class="s.icon"></i>
              </div>

              <div class="stepbar__label">{{ s.label }}</div>

              <div
                  v-if="idx !== steps.length - 1"
                  class="stepbar__line"
                  :class="{
        'line-done': idx < stepBarCurrentIndex,
        'line-todo': idx >= stepBarCurrentIndex
      }"
              ></div>
            </div>
          </div>

          <!-- STEP CONTENT -->
          <div class="text-center mt-15" >
            <div class="step-content__title">
              Bước {{ displayStep.index }}: {{ displayStep.label }}
            </div>
            <div class="step-content__desc">
              <div v-if="currentStep === 1 || currentStep === 2">
                Vui lòng kiểm tra đầy đủ thông tin hồ sơ vay của học viên<br />
                và ấn duyệt hoặc yêu cầu bổ sung thông tin.
                <div class="step-content__actions mt-4">
                  <el-button
                      size="mini"
                      class="btn-primary"
                      @click="$emit('view-profile')"
                  >
                    Xem hồ sơ ngay
                  </el-button>
                </div>
              </div>

              <div v-else-if="currentStep === 3">
                <Step2HandleFileContract @get-log="getHistory()" @next-step-3="handleNextStep(4)" @next-step-4="handleNextStep(5)" />
              </div>

              <div v-else-if="currentStep === 4">
                <Step3HandleFileContract />
              </div>

              <div v-else-if="currentStep === 5">
                <Step4HandleFileContract @next-step-5="handleNextStep(6)" />
              </div>

              <div v-else-if="currentStep === 6">
                <Step5HandleFileContract @next-step-6="handleNextStep(7)" />
              </div>

              <div v-else>
                <Step6HandleFileContract />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT: history -->
      <div class="process-right">
        <el-card shadow="hover" class="history-card">
          <div class="history-card__title">Lịch sử xử lý</div>
          <div class="history-card__divider"></div>

          <div class="history-list" style="overflow-y: scroll; max-height: 65vh">
            <div v-for="(h, idx) in history" :key="idx" class="history-item">
              <div class="history-item__header">
                <span class="history-item__name">{{ h.title }}</span>
              </div>

              <div class="history-item__body">
                <div class="history-row">
                  <div class="history-row__label"><b>Thời gian:</b></div>
                  <div class="history-row__value">{{ h.created_at }}</div>
                </div>

                <div v-if="h.note" class="history-row">
                  <div class="history-row__label"><b>Ghi chú:</b></div>
                  <div v-html="h.note"></div>
                </div>
              </div>
            </div>

            <div v-if="!history.length" class="history-empty">
              Chưa có lịch sử xử lý.
            </div>
          </div>
        </el-card>
      </div>
      <el-dialog
          class="cancel-contract-dialog"
          title="Hủy hợp đồng vay citime"
          :visible.sync="dialogCancelContractVisible"
          append-to-body
          :show-close="false"
          :lock-scroll="false"
          width="30%">
        <hr>
        <DialogCancelContract @close="dialogCancelContractVisible=false"></DialogCancelContract>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Step2HandleFileContract from "./Step2HandleFileContract.vue";
import Step3HandleFileContract from "./Step3HandleFileContract.vue";
import Step4HandleFileContract from "./Step4HandleFileContract.vue";
import Step5HandleFileContract from "./Step5HandleFileContract.vue";
import Step6HandleFileContract from "./Step6HandleFileContract.vue";
import DialogCancelContract from "./DialogCancelContract.vue";
import {PUSH_PERCENT_LOADING_IMPORT_SALE_LOG} from "../../../../core/services/store/user/users.module";
import {GET_INFO_BORROWER, GET_INFO_QR_CITIME} from "../../../../core/services/store/customer/customer-crm.module";

export default {
  name: "handle-file-contact",
  components: {
    Step6HandleFileContract,
    Step5HandleFileContract,
    Step4HandleFileContract,
    Step3HandleFileContract,
    Step2HandleFileContract,
    DialogCancelContract
  },
  props: {
    step: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading : false,
      currentStep: 0,
      dialogCancelContractVisible: false,
      steps: [
        { index: 1, key: "approve", label: "Duyệt hồ sơ", icon: "el-icon-document-checked" },
        { index: 2, key: "call", label: "Gọi điện tư vấn", icon: "el-icon-phone-outline" },
        { index: 3, key: "fee", label: "Thanh toán phí", icon: "el-icon-wallet" },
        { index: 4, key: "draft", label: "Soạn hợp đồng", icon: "el-icon-edit-outline" },
        { index: 5, key: "sign", label: "Ký hợp đồng", icon: "el-icon-edit" },
        { index: 6, key: "disburse", label: "Giải ngân", icon: "el-icon-circle-check" },
      ],
      history: [],
    };
  },

  watch: {
    step: {
      immediate: true,
      handler(v) {
        const n = Number(v);
        this.currentStep = Number.isFinite(n) ? n : 0;
      }
    }
  },

  computed: {
    safeStep() {
      return Math.min(Math.max(this.currentStep, 0), this.steps.length - 1);
    },

    displayStep() {
      if ([0, 1, 2].includes(this.currentStep)) return this.steps[0];
      if (this.currentStep === 3) return this.steps[1];
      if (this.currentStep === 4) return this.steps[2];
      if (this.currentStep === 5) return this.steps[3];
      if (this.currentStep === 6) return this.steps[4];
      return this.steps[5];
    },

    stepBarCurrentIndex() {
      return this.mapProcessToStepBar(this.currentStep);
    },

    stepBarMaxIndex() {
      return this.mapProcessToStepBar(this.step);
    }
  },

  mounted() {
    this.getHistory();
  },

  methods: {
    getHistory() {
      const contractId = this.$route.params.id;
      this.$store.dispatch(GET_INFO_BORROWER, { id: contractId })
          .then((res) => {
            this.history = res.data.processing_logs || [];
          })
          .catch(() => {
            this.history = [];
          });
    },

    mapProcessToStepBar(step) {
      const n = Number(step);

      if ([0, 1, 2].includes(n)) return 0;
      if (n === 3) return 1;
      if (n === 4) return 2;
      if (n === 5) return 3;
      if (n === 6) return 4;

      return 5;
    },

    mapStepBarToProcess(idx) {
      const map = {
        0: 1,
        1: 3,
        2: 4,
        3: 5,
        4: 6,
        5: 7,
      };

      return map[idx] ?? 0;
    },

    changeStepBar(idx) {
      if (idx > this.stepBarMaxIndex) return;
      this.currentStep = this.mapStepBarToProcess(idx);
    },

    handleNextStep(step, item) {
      if(!item) {
        this.currentStep = step;
      }
      this.getHistory();
    }
  },
};
</script>

<style scoped>
.process-wrap {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

/* LEFT */
.process-left {
  flex: 1;
  min-width: 0;
}

.process-left__box {
  border: 3px solid #1f73ff; /* viền xanh giống ảnh */
  border-radius: 2px;
  background: #fff;
  padding: 18px 18px 26px;
  min-height: 100%;
}

/* stepbar */
.stepbar {
  display: flex;
  align-items: flex-start;
  padding: 8px 4px 14px;
}

.stepbar__item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 6px;
}

.stepbar__icon {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 2px solid #cfd6e4;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  font-size: 14px;
  color: #9aa6bd;
}

.stepbar__label {
  font-size: 12px;
  color: #8b95a7;
  white-space: nowrap;
}

.stepbar__line {
  width: 58px;
  height: 2px;
  margin-left: 8px;
  transform: translateY(-2px);
  background-image: repeating-linear-gradient(
      to right,
      #cfd6e4 0,
      #cfd6e4 3px,
      transparent 3px,
      transparent 7px
  );
}

.stepbar__item.is-done .stepbar__icon i,
.stepbar__item.is-active .stepbar__icon,
.stepbar__item.is-active .stepbar__icon i,
.stepbar__item.is-done .stepbar__icon {
  border-color: #1f73ff;
  color: #1f73ff !important;
  cursor: pointer;
}


.stepbar__item.is-active .stepbar__label i,
.stepbar__item.is-active .stepbar__label,
.stepbar__item.is-done .stepbar__label {
  color: #1f73ff !important;
  font-weight: 600;
  cursor: pointer;
}


.stepbar__line.line-done {
  background-image: repeating-linear-gradient(
      to right,
      #1f73ff 0,
      #1f73ff 3px,
      transparent 3px,
      transparent 7px
  );
}

.step-content__title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.step-content__desc {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 16px;
}

.step-content__actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn-primary {
  background: #5d04b0 !important;
  border-color: #5d04b0 !important;
  color: #fff !important;
}

/* RIGHT */
.process-right {
  width: 380px;
  min-width: 320px;
}

.history-card {
  border-radius: 8px;
  min-height: 100%;
}

.history-card__title {
  font-weight: 700;
  font-size: 13px;
  color: #333;
  margin-bottom: 10px;
}

.history-card__divider {
  height: 1px;
  background: #eaecef;
  margin-bottom: 12px;
}

.history-item {
  border: 1px solid #eaecef;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.history-item__header {
  display: flex;
  gap: 4px;
  align-items: baseline;
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f2f5;
  padding-bottom: 8px;
}

.history-item__name {
  color: #4c2bbd;
  font-weight: 700;
  font-size: 12px;
}


.history-row {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 8px;
  font-size: 12px;
  margin: 6px 0;
}

.history-row__label {
  color: #666;
}

.history-row__value {
  color: #333;
}

.history-empty {
  font-size: 12px;
  color: #888;
  padding: 10px 0;
}

:deep .cancel-contract-dialog .el-dialog__body {
  padding: 0px 20px 20px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

/* responsive */
@media (max-width: 1906px) {
  .process-wrap {
    flex-direction: column;
  }
  .process-right {
    width: 100%;
  }
  .stepbar {
    flex-wrap: wrap;
    gap: 10px;
  }
  .process-left__box {
    display: flex;
  }
  .stepbar__line {
    display: none;
  }
}

@media (max-width: 1200px) {
  .process-left__box {
    display: block;
  }
}
</style>


